import { BRAND_CODE } from "@/config/common";
import type { MarketConfiguration } from "@/config/markets/const";

/**
 *
 * @param attributes extra attributes to include.
 * @returns default set of attributes used in the app.
 */
export default function mapCustomAttributes(
  attributes: string[] = [],
  market: MarketConfiguration,
) {
  return [
    `number.rrp_${BRAND_CODE}_${market.code.toLowerCase()}`,
    "stockStatus",
    "variantFlags",
    "productFlags",
    "nextDeliveryDate",
    "number.stockOnHand",
    "number.delivery_time_days",
    "json.imagesKey",
    "json.productImageURLKey",
    "json.v2_productMainImageKey",
    "json.v2_productAdditionalImageKey",
    "json.v2_variantMainImageKey",
    "json.v2_variantAdditionalImageKey",
    "json.variantName",
    "leafCategoryCodes",
    "totalCategoryCodes",
    "bestStockStatus",
    "itemStatus",
    "defaultProductPartNo",
    "defaultProductImageKey",
    "defaultProductNG_PartNo",
    "defaultProductNG_ImageKey",
    "statuses",
    "productCode",
    `${BRAND_CODE}_${market.code.toLowerCase()}_fromPriceType`,
    `${BRAND_CODE}_${market.code.toLowerCase()}_fromPriceSame`,
    `number.rrp_${BRAND_CODE}_${market.code.toLowerCase()}`,
    `number.${BRAND_CODE}_${market.code.toLowerCase()}_fromPrice`,
    `number.${BRAND_CODE}_${market.code.toLowerCase()}_fromPriceRRP`,
    `number.${BRAND_CODE}_${market.code.toLowerCase()}_fromPrice30Days`,
    ...attributes,
  ];
}
